import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styled, { css } from 'styled-components';
import theme from 'styled-theming';
import { Button } from '../button/index.js';
import { List, ListItem as ListItem$1 } from '../list/index.js';
import { NAV_VARIANTS } from './constants.js';
import { PLACEMENTS } from '../dropdown/constants.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22;

/** Top-level wrapper, dropdown needs a parent */
const Wrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__Wrapper",
  componentId: "sc-a71id-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-flex;\n"])));

/**
 * We want all the menus in the same position,
 * so create a grid and position all immediate children
 * in the same spot.
 *
 * DropdownContent handles the `menu` accessibility,
 * so this div is purely presentational.
 */
const MenuWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__MenuWrapper",
  componentId: "sc-a71id-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-areas: 'stack';\n  overflow: hidden;\n  width: ", ";\n\n  > * {\n    grid-area: stack;\n  }\n"])), _ref => {
  let {
    width
  } = _ref;
  return width;
});
const PanelWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__PanelWrapper",
  componentId: "sc-a71id-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: relative;\n\n  &.appear,\n  &.enter {\n    opacity: 0;\n    transform: ", ";\n  }\n\n  &.appear-active,\n  &.enter-active {\n    opacity: 1;\n    transform: translateX(0);\n    transition: ", ";\n  }\n\n  &.exit {\n    opacity: 1;\n  }\n\n  &.exit-active {\n    opacity: 0;\n    transition: ", ";\n    transform: ", ";\n  }\n"])), _ref2 => {
  let {
    menuDirection,
    isRtl
  } = _ref2;
  if (menuDirection === 'up') {
    return isRtl ? 'translateX(100%)' : 'translateX(-100%)';
  }
  if (menuDirection === 'down') {
    return isRtl ? 'translateX(-100%)' : 'translateX(100%)';
  }
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.transitionsMs.default;
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.transitionsMs.default;
}, _ref5 => {
  let {
    menuDirection,
    isRtl
  } = _ref5;
  if (menuDirection === 'up') {
    return isRtl ? 'translateX(-100%)' : 'translateX(100%)';
  }
  if (menuDirection === 'down') {
    return isRtl ? 'translateX(100%)' : 'translateX(-100%)';
  }
});
const MenuList = /*#__PURE__*/styled(List).withConfig({
  displayName: "styles__MenuList",
  componentId: "sc-a71id-3"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  padding: ", ";\n"])), _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.spacing.halfSpacing;
});
const ListItem = /*#__PURE__*/styled(ListItem$1).withConfig({
  displayName: "styles__ListItem",
  componentId: "sc-a71id-4"
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", "\n\n  ", "\n"])), _ref7 => {
  let {
    divider,
    theme
  } = _ref7;
  return divider && css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n      margin-block-start: ", ";\n      padding-block-start: ", ";\n      border-block-start: 1px solid ", ";\n    "])), theme.spacing.halfSpacing, theme.spacing.halfSpacing, theme.colors.opacities.default);
}, _ref8 => {
  let {
    isBackButton,
    theme
  } = _ref8;
  return isBackButton && css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      margin-block-end: ", ";\n      padding-block-end: ", ";\n      border-block-end: 1px solid ", ";\n    "])), theme.spacing.halfSpacing, theme.spacing.halfSpacing, theme.colors.opacities.default);
});
const ButtonText = /*#__PURE__*/styled.span.withConfig({
  displayName: "styles__ButtonText",
  componentId: "sc-a71id-5"
})(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  &[dir='ltr'] {\n    font-family: ", ";\n  }\n\n  &[dir='rtl'] {\n    font-family: ", ";\n  }\n"])), _ref9 => {
  let {
    theme
  } = _ref9;
  return theme.fonts.heading;
}, _ref10 => {
  let {
    theme
  } = _ref10;
  return theme.rtlFonts.body;
});

/** Over-rides/additions per theme */
const buttonPrimaryThemeStyles = theme('name', {
  pureGym: css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    text-transform: uppercase;\n    font-size: 3rem;\n    font-style: italic;\n  "])))
});
const dropdownButtonStyles = css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  padding: ", ";\n  background: transparent;\n  border: none;\n  box-shadow: none;\n  color: ", ";\n\n  color: ", ";\n\n  &[dir='rtl'] {\n    font-family: ", ";\n  }\n\n  &:not(:disabled) {\n    &:hover,\n    &:focus,\n    &:active {\n      background: ", ";\n      color: ", ";\n    }\n  }\n\n  &:disabled {\n    color: currentColor;\n    opacity: ", ";\n  }\n"])), _ref11 => {
  let {
    theme
  } = _ref11;
  return theme.spacing.halfSpacing;
}, _ref12 => {
  let {
    theme
  } = _ref12;
  return theme.colors.text;
}, _ref13 => {
  let {
    theme: {
      fonts
    }
  } = _ref13;
  return theme('name', {
    pureGym: css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n        font-family: ", ";\n      "])), fonts.heading)
  });
}, _ref14 => {
  let {
    theme
  } = _ref14;
  return theme.rtlFonts.body;
}, _ref15 => {
  let {
    theme
  } = _ref15;
  return theme.colors.accents.muted;
}, _ref16 => {
  let {
    theme
  } = _ref16;
  return theme.colors.text;
}, _ref17 => {
  let {
    theme
  } = _ref17;
  return theme.opacities.disabled;
});
const globalNavButtonStyles = css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  padding: ", ";\n\n  &:focus-visible {\n    box-shadow: ", ";\n  }\n"])), _ref18 => {
  let {
    theme
  } = _ref18;
  return theme.fontSizes.xlarge;
}, _ref19 => {
  let {
    theme
  } = _ref19;
  return "".concat(theme.spacing.halfSpacing, " ").concat(theme.spacing.baseSpacing);
}, _ref20 => {
  let {
    theme
  } = _ref20;
  return "0 0 0 2px ".concat(theme.colors.primary.light);
});
const MenuButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "styles__MenuButton",
  componentId: "sc-a71id-6"
})(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-weight: normal;\n  text-transform: none;\n\n  [dir='rtl'] & {\n    font-family: ", ";\n  }\n\n  > svg {\n    font-size: 1em;\n  }\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"])), _ref21 => {
  let {
    theme
  } = _ref21;
  return theme.fonts.body;
}, _ref22 => {
  let {
    theme
  } = _ref22;
  return theme.rtlFonts.body;
}, _ref23 => {
  let {
    menuVariant
  } = _ref23;
  switch (menuVariant) {
    case NAV_VARIANTS.DROPDOWN:
      return dropdownButtonStyles;
    case NAV_VARIANTS.GLOBAL:
      return globalNavButtonStyles;
    // no default
  }
}, _ref24 => {
  let {
    isBackButton,
    theme
  } = _ref24;
  return isBackButton && css(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n      padding: ", ";\n    "])), theme.spacing.halfSpacing);
}, _ref25 => {
  let {
    active,
    theme: {
      colors
    }
  } = _ref25;
  return active && css(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n      background: ", ";\n      cursor: default;\n\n      &:not(:disabled) {\n        &:hover,\n        &:active,\n        &:focus {\n          background: ", ";\n        }\n      }\n    "])), colors.opacities.strong, colors.opacities.strong);
}, _ref26 => {
  let {
    primary,
    theme
  } = _ref26;
  return primary && css(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n      font-family: ", ";\n      font-size: ", ";\n      ", ";\n      [dir='rtl'] & {\n        font-family: ", ";\n        font-style: normal;\n      }\n    "])), theme.fonts.heading, theme.fontSizes.xxlarge, buttonPrimaryThemeStyles, _ref27 => {
    let {
      theme
    } = _ref27;
    return theme.rtlFonts.heading;
  });
});
const CloseButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "styles__CloseButton",
  componentId: "sc-a71id-7"
})(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  align-self: flex-end;\n  margin: ", ";\n  margin-block-end: 0;\n  padding: ", ";\n  font-size: ", ";\n  color: ", ";\n\n  > svg {\n    font-size: 1em;\n  }\n\n  &:focus-visible {\n    box-shadow: ", ";\n  }\n"])), _ref28 => {
  let {
    theme
  } = _ref28;
  return theme.spacing.baseSpacing;
}, _ref29 => {
  let {
    theme
  } = _ref29;
  return "".concat(theme.spacing.halfSpacing, " ").concat(theme.spacing.baseSpacing);
}, _ref30 => {
  let {
    theme
  } = _ref30;
  return theme.fontSizes.large;
}, _ref31 => {
  let {
    theme
  } = _ref31;
  return theme.colors.textMuted;
}, _ref32 => {
  let {
    theme
  } = _ref32;
  return "0 0 0 2px ".concat(theme.colors.primary.light);
});

/** Dropdown */
const DropdownContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__DropdownContainer",
  componentId: "sc-a71id-8"
})(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  visibility: hidden;\n  position: absolute;\n  z-index: 20;\n  width: max-content;\n\n  background: ", ";\n  box-shadow: ", ";\n  border-radius: ", ";\n\n  ", ";\n\n  &.appear,\n  &.enter {\n    opacity: 0;\n    visibility: visible;\n    transform: ", ";\n  }\n\n  &.appear-active,\n  &.enter-active {\n    opacity: 1;\n    visibility: visible;\n    transform: translateY(0);\n    transition: ", ";\n  }\n\n  &.appear-done,\n  &.enter-done,\n  &.exit {\n    visibility: visible;\n  }\n\n  &.exit-active {\n    opacity: 0;\n    visibility: visible;\n    transform: ", ";\n    transition: ", ";\n  }\n\n  &.exit-done {\n    opacity: 0;\n    visibility: hidden;\n  }\n"])), _ref33 => {
  let {
    theme
  } = _ref33;
  return theme.colors.surface;
}, _ref34 => {
  let {
    theme
  } = _ref34;
  return theme.boxShadows.default;
}, _ref35 => {
  let {
    theme
  } = _ref35;
  return theme.radii.default;
}, _ref36 => {
  let {
    placement
  } = _ref36;
  switch (placement) {
    case PLACEMENTS.BOTTOM_START:
      {
        return css(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n          top: 100%;\n          left: 0;\n          [dir='rtl'] & {\n            left: auto;\n            right: 0;\n          }\n        "])));
      }
    case PLACEMENTS.BOTTOM_END:
      {
        return css(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n          top: 100%;\n          right: 0;\n          [dir='rtl'] & {\n            right: auto;\n            left: 0;\n          }\n        "])));
      }
    // no default
  }
}, _ref37 => {
  let {
    theme
  } = _ref37;
  return "translateY(-".concat(theme.spacing.halfSpacing, ")");
}, _ref38 => {
  let {
    theme
  } = _ref38;
  return theme.transitionsMs.default;
}, _ref39 => {
  let {
    theme
  } = _ref39;
  return "translateY(".concat(theme.spacing.baseSpacing, ")");
}, _ref40 => {
  let {
    theme
  } = _ref40;
  return theme.transitionsMs.default;
});

/** Main nav variant */
const GlobalNavWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__GlobalNavWrapper",
  componentId: "sc-a71id-9"
})(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n  visibility: hidden;\n  position: fixed;\n  z-index: 200;\n  top: 0;\n  left: 0;\n  transform: ", ";\n\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  background-color: ", ";\n  overflow-x: auto;\n\n  color: ", ";\n\n  [dir='rtl'] & {\n    left: auto;\n    right: 0;\n  }\n\n  *:not(:disabled) {\n    *:focus-visible {\n      box-shadow: ", ";\n    }\n  }\n\n  &.appear,\n  &.enter {\n    visibility: visible;\n    transform: ", ";\n  }\n\n  &.appear-done,\n  &.enter-done,\n  &.exit {\n    visibility: visible;\n    transform: translateX(0);\n  }\n\n  // https://easings.net/#easeOutExpo\n  &.appear-active,\n  &.enter-active {\n    visibility: visible;\n    transform: translateX(0);\n    transition: ", ";\n  }\n\n  &.exit-active {\n    visibility: visible;\n    transition: ", ";\n    transform: ", ";\n  }\n\n  &.exit-done {\n    visibility: hidden;\n    transform: ", ";\n  }\n"])), _ref41 => {
  let {
    isRtl
  } = _ref41;
  return isRtl ? 'translateX(100%)' : 'translateX(-100%)';
}, _ref42 => {
  let {
    theme
  } = _ref42;
  return theme.colors.accents.dark;
}, _ref43 => {
  let {
    theme: {
      colors
    }
  } = _ref43;
  return theme('mode', {
    light: colors.contrastText,
    dark: colors.text
  });
}, _ref44 => {
  let {
    theme
  } = _ref44;
  return "0 0 0 2px ".concat(theme.colors.primary.light);
}, _ref45 => {
  let {
    isRtl
  } = _ref45;
  return isRtl ? 'translateX(100%)' : 'translateX(-100%)';
}, _ref46 => {
  let {
    theme
  } = _ref46;
  return "".concat(theme.transitionsMs.default, " cubic-bezier(0.16, 1, 0.3, 1)");
}, _ref47 => {
  let {
    theme
  } = _ref47;
  return "".concat(theme.transitionsMs.default, " cubic-bezier(0.16, 1, 0.3, 1)");
}, _ref48 => {
  let {
    isRtl
  } = _ref48;
  return isRtl ? 'translateX(100%)' : 'translateX(-100%)';
}, _ref49 => {
  let {
    isRtl
  } = _ref49;
  return isRtl ? 'translateX(100%)' : 'translateX(-100%)';
});
const Overlay = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__Overlay",
  componentId: "sc-a71id-10"
})(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n  position: fixed;\n  z-index: 150;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: ", ";\n\n  &.appear,\n  &.enter {\n    opacity: 0;\n  }\n\n  &.appear-active,\n  &.enter-active {\n    opacity: 1;\n    transition: ", ";\n  }\n\n  &.exit {\n    opacity: 1;\n  }\n\n  &.exit-active {\n    opacity: 0;\n    transition: ", ";\n  }\n"])), _ref50 => {
  let {
    theme
  } = _ref50;
  return theme.colors.opacities.invertedStrong;
}, _ref51 => {
  let {
    theme
  } = _ref51;
  return "opacity ".concat(theme.transitionsMs.default);
}, _ref52 => {
  let {
    theme
  } = _ref52;
  return "opacity ".concat(theme.transitionsMs.default);
});

export { ButtonText, CloseButton, DropdownContainer, GlobalNavWrapper, ListItem, MenuButton, MenuList, MenuWrapper, Overlay, PanelWrapper, Wrapper };
